import React from "react";
import { GuestProfile } from "@closerplatform/spinner-openapi";
import { DownshiftState } from "downshift";
import { GuestPresenter } from "@fidget/common/utils/userPresenter";
import { HighlighterSpan } from "@fidget/common/components/text/highlighterSpan/highlighterSpan";
import styles from "./guestDropdownItem.css";
import { isSupportedCountry, parsePhoneNumber } from "libphonenumber-js";

const GuestDropdownItem = React.memo(
  ({
    inputValue,
    guestId,
    item: profile
  }: {
    item: Pick<
      GuestProfile,
      "phone" | "firstName" | "lastName" | "email" | "searchableField" | "roomId"
    >;
    guestId: string;
    inputValue: DownshiftState<unknown>["inputValue"];
  }) => {
    const presenter = new GuestPresenter({ ...profile, id: guestId });
    const phoneRegion =
      presenter?.phone && isSupportedCountry(presenter.phone.region)
        ? presenter.phone.region
        : undefined;
    const phoneNumber = presenter.phone
      ? parsePhoneNumber(presenter.phone.number, {
          defaultCountry: phoneRegion
        }).formatInternational()
      : "";

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <HighlighterSpan
            text={profile.firstName || ""}
            highlightWord={inputValue}
            textClassName={styles.text}
          />{" "}
          <HighlighterSpan
            text={profile.lastName || ""}
            highlightWord={inputValue}
            textClassName={styles["text-description"]}
          />
        </div>
        {profile.email && (
          <HighlighterSpan
            text={profile.email}
            highlightWord={inputValue}
            textClassName={styles["text-description"]}
          />
        )}
        {phoneNumber && (
          <HighlighterSpan
            text={phoneNumber}
            highlightWord={inputValue}
            textClassName={styles["text-description"]}
          />
        )}
        {profile.roomId && (
          <HighlighterSpan
            text={profile.roomId}
            highlightWord={inputValue}
            textClassName={styles["text-description"]}
          />
        )}
        {profile.searchableField && (
          <HighlighterSpan
            text={profile.searchableField}
            highlightWord={inputValue}
            textClassName={styles["text-description"]}
          />
        )}
      </div>
    );
  }
);

export const GuestDropdownItemGuestProfile = ({
  inputValue,
  item
}: {
  inputValue: DownshiftState<GuestProfile>["inputValue"];
  item: GuestProfile;
}) => {
  return <GuestDropdownItem guestId={item.id} inputValue={inputValue} item={item} />;
};
